import React from "react";
import MultyLineTextView from "@/pcomponents/common/crud/view/multy_line_text";
import TextAreaComponent from "@/pcomponents/common/crud/write/textarea";
import Style from "./css/style.module.css";
import content_page_data_arr from "./data/page_data";

function ContentPageArea(props: any) {
  let myProps = {
    info: {},
    setInfo: (inInfo: any) => { },
    is_write_mode: false,
    ...props
  };
  let info = myProps.info;
  let is_write_mode = myProps.is_write_mode;
  let number_back_circle_src = process.env.REACT_APP_API_URL + "/img/comp/edu/comp_stu_prescribe/number_back_circle.png";
  let page_max_height = 1000 - 30 - 70;

  const handleInputChange = (inData: any) => {
    let opt_obj = {
      name: "",
      value: "",
      ...inData,
    };
    let name = opt_obj.name;
    let value = opt_obj.value;

    let change_info = { ...info };
    change_info[name] = value;
    myProps.setInfo(change_info);
  };

  const get_page_tr_tags = (inData: any) => {
    let opt_obj = {
      p_data_arr: [],
      ...inData
    };

    let split_h_cnt = 0;
    for (let i = 0; i < opt_obj.p_data_arr.length; i++) {
      split_h_cnt += opt_obj.p_data_arr[i].h_ratio;
    }

    let tr_tags = opt_obj.p_data_arr.map((p_data: any, index: number) => {

      let tr_row_h = 0;
      if (split_h_cnt > 0 && page_max_height > 0) {
        tr_row_h = (page_max_height / split_h_cnt) * p_data.h_ratio;
      };
      let th_text_style=p_data.th_text_style;

      return (
        <tr key={index}>
          <th>
            <div className={Style.left_th_con} style={{ minHeight: tr_row_h + "px" }}>
              <span style={th_text_style}>
                {p_data.title.split("\n").map((line: string, line_index: number) => (
                  <React.Fragment key={line_index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </span>
            </div>
          </th>
          <td>
            <div className={Style.table_box+" hamchorom"}>
              {is_write_mode == false ?
                <MultyLineTextView text={info[p_data.key]}></MultyLineTextView>
                :
                <TextAreaComponent
                  class_name={Style.box_textarea}
                  name={p_data.key}
                  value={info[p_data.key]}
                  onChange={(e: any) => {
                    handleInputChange({ name: p_data.key, value: e.target.value });
                  }}
                  style={{ minHeight: (tr_row_h - 22) + "px" }}
                ></TextAreaComponent>
              }
            </div>
          </td>
          <td>
            <div className={Style.table_box+" "+Style.table_box_memo+" hamchorom"}>
              {is_write_mode == false ?
                <MultyLineTextView text={info[p_data.memo_key]}></MultyLineTextView>
                :
                <TextAreaComponent
                  class_name={Style.box_textarea}
                  name={p_data.memo_key}
                  value={info[p_data.memo_key]}
                  onChange={(e: any) => {
                    handleInputChange({ name: p_data.memo_key, value: e.target.value });
                  }}
                  style={{ minHeight: (tr_row_h - 22) + "px" }}
                ></TextAreaComponent>
              }
            </div>
          </td>
        </tr>
      );
    });

    return tr_tags;
  };

  const get_content_page_tags = () => {
    let page_tags = content_page_data_arr.map((content_page_data: any, index: number) => {
      let page_table_wrap_class=Style.content_table_wrap;
      if(content_page_data.is_result_page){
        page_table_wrap_class+=" "+Style.content_table_wrap_result;
      }

      return (
        <div key={index} className={"a4subpage " + Style.content_wrap} >
          <div className={Style.content_con} >
            <div className={page_table_wrap_class}>
              {content_page_data.page_num_str &&
                <span className={Style.number_back_circle}>
                  <div className={Style.number_back_circle_con}>
                    <img src={number_back_circle_src} alt="Number Back Circle" />
                    <span className={Style.number_back_circle_text}>{content_page_data.page_num_str}</span>
                  </div>
                </span>
              }
              <table>
                <colgroup>
                  <col width={"90px"}></col>
                  <col width={"*"}></col>
                  <col width={"100px"}></col>
                </colgroup>
                <tbody>
                  <tr>
                    <th></th>
                    <th>{content_page_data.title}</th>
                    <th>{content_page_data.memo}</th>
                  </tr>
                  {get_page_tr_tags({ 
                    p_data_arr: content_page_data.arr
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      );
    });

    return page_tags;
  };

  return (
    <>{get_content_page_tags()}</>
  );
};
export default ContentPageArea;